import { render, staticRenderFns } from "./advanceTableSettings.vue?vue&type=template&id=50f5a0b7"
import script from "./advanceTableSettings.vue?vue&type=script&lang=js"
export * from "./advanceTableSettings.vue?vue&type=script&lang=js"
import style0 from "./advanceTableSettings.vue?vue&type=style&index=0&id=50f5a0b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports